import React from "react";
import { Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import Login from "../Login/Login";
import "../App.css";
import { Error } from "../Generic/404";
import MachineRoute from "../Routing/MachineRoute";
import MachineSelect from "../Landing/MachineSelect";
import FoodMaking from "../Kiosk/FoodMaking";
import Inventory from "../Inventory/Inventory";
import "react-toastify/dist/ReactToastify.css";
import RecentOrders from "../Orders/RecentOrders";
import OrderDetails from "../Orders/OrderDetails";
import Task from "../Tasks/Task";
import TaskList from "../Tasks/TaskList";
import Replenish from "../Inventory/Replenish";
import { AppRoutes, DashboardModules, KioskSubModules, StudioSubModules, AdminSubModules } from "../config/app.config";
import GodMode from "../Kiosk/GodMode";
import ActiveTasks from "../Tasks/ActiveTasks";
import StudioRoute from "../Routing/StudioRoute";
import AdminRoute from "../Routing/AdminRoute";
import IngredientDetails from "../CookBook/Ingredients/IngredientDetails";
import IngredientList from "../CookBook/Ingredients/IngredientList";
import IngredientEdit from "../CookBook/Ingredients/IngredientEdit";
import IngredientCreate from "../CookBook/Ingredients/IngredientCreate";
import RecipeCreate from "../CookBook/Recipes/RecipeCreate";
import RecipeDetails from "../CookBook/Recipes/RecipeDetails";
import RecipeList from "../CookBook/Recipes/RecipeList";
import RecipeEdit from "../CookBook/Recipes/RecipeEdit";
import { RecipeProvider } from "../CookBook/Recipes/context/RecipeContext";
import { DishProvider } from "../CookBook/Dishes/context/DishContext";
import DishList from "../CookBook/Dishes/DishList";
import DishDetails from "../CookBook/Dishes/DishDetails";
import DishEdit from "../CookBook/Dishes/DishEdit";
import DishCreate from "../CookBook/Dishes/DishCreate";
import XookeeperPlannedTasks from "../Operations/Xookeeper/plannedTasks";
import XookeeperPastTasks from "../Operations/Xookeeper/pastTasks";
import SearchTasks from "../Tasks/SearchTasks";
import ApplyOffers from "../Offers/ApplyOffers";
import AuthenticatedRoute from "./AuthenticatedRoute";
import AuthorizedRoute from "./AuthorizedRoute";
import MachineIndexRoute from "./MachineIndexRoute";
import { Unauthorized } from "../Generic/Unauthorized";
import KitchenModules from "../Kiosk/KitchenModules";
import BalanceSheet from "../Business/BalanceSheet";
import AppLayout from "../Layout/AppLayout";
import AuditLogs from "../Admin/Logs/AuditLogs";

const KioskRoutes = AppRoutes[DashboardModules.KIOSK];
const StudioRoutes = AppRoutes[DashboardModules.STUDIO];
const AdminRoutes = AppRoutes[DashboardModules.ADMIN];

const RecipeRoutesLayout = () => (
	<RecipeProvider>
		<Outlet />
	</RecipeProvider>
);

const DishRoutesLayout = () => (
	<DishProvider>
		<Outlet />
	</DishProvider>
);

const DashboardRoutes = ({ isLoggedIn = false, role }) => {
	const location = useLocation();
	return (
		// <SwitchTransition>
		// 	<CSSTransition
		// 		key={location.pathname.split("/")[1]}
		// 		timeout={300}
		// 		classNames="page"
		// 		unmountOnExit>
		<Routes location={location}>
			<Route path="/login" element={<Login />} />
			<Route path="/unauthorized" element={<Unauthorized />} />
			<Route path="/404" element={<Error />} />


			{/* Default route*/}
			<Route path="/" element={<Navigate to={"/home"} replace />} />

			<Route element={<AuthenticatedRoute login={isLoggedIn} role={role} />}>
				<Route path="/home" element={<AuthorizedRoute />}>
					<Route path="" element={<AppLayout><MachineSelect /></AppLayout>} />
				</Route>
				<Route path="/admin/*" element={<AuthorizedRoute />}>
					<Route element={<AdminRoute />}>
						<Route path="" element={<Navigate to={AdminRoutes[AdminSubModules.LOGS].AUDIT_LOGS.path} replace />} />
						<Route
							path={AdminRoutes[AdminSubModules.LOGS].AUDIT_LOGS.path}
							element={<AuditLogs />}
						/>
					</Route>
				</Route>
				<Route path="/:machineId/*" element={<AuthorizedRoute />}>
					<Route element={<MachineRoute />}>
						<Route path="" element={<MachineIndexRoute />} />
						<Route path={KioskRoutes[KioskSubModules.MACHINE].KITCHEN_MODULES.path} element={<KitchenModules />} />
						<Route path={KioskRoutes[KioskSubModules.MACHINE].GOD_MODE.path} element={<GodMode />} />
						<Route path={KioskRoutes[KioskSubModules.MACHINE].FOODMAKING.path} element={<FoodMaking />} />
						<Route path={KioskRoutes[KioskSubModules.TASKS].RECENT_TASKS.path} element={<TaskList />} />
						<Route path={KioskRoutes[KioskSubModules.TASKS].ACTIVE_TASKS.path} element={<ActiveTasks />} />
						<Route path={KioskRoutes[KioskSubModules.TASKS].SEARCH_TASKS.path} element={<SearchTasks />} />
						<Route path={KioskRoutes[KioskSubModules.TASKS].TASK.path} element={<Task />} />
						<Route path={KioskRoutes[KioskSubModules.INVENTORY].INVENTORY_SNAPSHOT.path} element={<Inventory />} />
						<Route path={KioskRoutes[KioskSubModules.INVENTORY].REPLENISH.path} element={<Replenish />} />
						<Route path={KioskRoutes[KioskSubModules.ORDERS].RECENT_ORDERS.path} element={<RecentOrders />} />
						<Route path={KioskRoutes[KioskSubModules.ORDERS].ORDER_DETAILS.path} element={<OrderDetails />} />
						<Route path={KioskRoutes[KioskSubModules.OFFERS].APPLY.path} element={<ApplyOffers />} />
						<Route path={KioskRoutes[KioskSubModules.BUSINESS].BALANCE_SHEET.path} element={<BalanceSheet />} />
						<Route path={KioskRoutes[KioskSubModules.OPERATIONS].XOOKEEPER_PLANNED_TASKS.path} element={<XookeeperPlannedTasks />} />
						<Route path={KioskRoutes[KioskSubModules.OPERATIONS].XOOKEEPER_PAST_TASKS.path} element={<XookeeperPastTasks />} />
						<Route path="*" element={<Error />} />
					</Route>
				</Route>

				<Route path="/studio/*" element={<AuthorizedRoute />}>
					<Route element={<StudioRoute />}>
						<Route path="" element={<Navigate to={StudioRoutes[StudioSubModules.RECIPE].RECIPE_LIST.path} replace />} />
						<Route element={<RecipeRoutesLayout />}>
							<Route
								path={StudioRoutes[StudioSubModules.RECIPE].RECIPE_LIST.path}
								element={<RecipeList />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.RECIPE].RECIPE_CREATE.path}
								element={<RecipeCreate />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.RECIPE].RECIPE_EDIT.path}
								element={<RecipeEdit />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.RECIPE].RECIPE_DETAILS.path}
								element={<RecipeDetails />}
							/>
						</Route>
						<Route path={StudioRoutes[StudioSubModules.INGREDIENT].INGREDIENT_CREATE.path} element={<IngredientCreate />} />
						<Route path={StudioRoutes[StudioSubModules.INGREDIENT].INGREDIENT_EDIT.path} element={<IngredientEdit />} />
						<Route path={StudioRoutes[StudioSubModules.INGREDIENT].INGREDIENT_DETAILS.path} element={<IngredientDetails />} />
						<Route path={StudioRoutes[StudioSubModules.INGREDIENT].INGREDIENT_LIST.path} element={<IngredientList />} />
						<Route element={<DishRoutesLayout />}>
							<Route
								path={StudioRoutes[StudioSubModules.DISH].DISH_CREATE.path}
								element={<DishCreate />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.DISH].DISH_EDIT.path}
								element={<DishEdit />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.DISH].DISH_DETAILS.path}
								element={<DishDetails />}
							/>
							<Route
								path={StudioRoutes[StudioSubModules.DISH].DISH_LIST.path}
								element={<DishList />}
							/>
						</Route>
					</Route>
				</Route>
			</Route>

			<Route path="*" element={<Error />} />
		</Routes>
		// 	</CSSTransition>
		// </SwitchTransition>
	);
};

export default DashboardRoutes;
